<template>
  <v-row>
    <!-- Advanced usage  -->
    <v-col md="12">
      <base-card class="h-full">
        <v-card-title>
          Liste den Praktikanten
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-list>
              <v-list-item
                v-for="(child, i) in interns"
                :key="i"
              >
                <v-list-item-avatar>
                  <v-img :src="child.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="child.name" />
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle v-text="child.title" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {

    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Interns',
    },
    data () {
      return {
        interns: [
          {
            avatar: 'https://avatars.githubusercontent.com/u/20047564?v=4&s=460',
            name: 'John Leider',
            title: 'KV Dienstleistung & Administration',
          },
          {
            avatar: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
            name: 'Muster Doe',
            title: 'Eidgenössischer KV-Abschluss mit Berufsmaturität (BM1)',
          },
          {
            avatar: 'https://avatars.githubusercontent.com/u/60057364?v=4&s=460',
            name: 'Frau Muster',
            title: 'Administration & Handel',
          },
        ],
        lorem: 'Lorem ipsum dolor sit amet, at aliquam vivendum vel, everti delicatissimi cu eos. Dico iuvaret debitis mel an, et cum zril menandri. Eum in consul legimus accusam. Ea dico abhorreant duo, quo illum minimum incorrupte no, nostro voluptaria sea eu. Suas eligendi ius at, at nemore equidem est. Sed in error hendrerit, in consul constituam cum.',
      }
    },
  }
</script>
